import {
    PINA_INSURANCE_PICKER_USE_DROPDOWN_CHEVRON,
    VARIANT_ON,
} from '../../config/ab/experiments';

export const useDropdownHeaderChevron = state => {
    return state[PINA_INSURANCE_PICKER_USE_DROPDOWN_CHEVRON.experimentId] === VARIANT_ON;
};
